export const getProduct = (productId) => ({ product: { productsList } }) =>
  productsList.find(({ id }) => id === +productId);
